module.exports = __webpack_public_path__ + "media/images/lp/bg_feature4-51c37fce7d20257b00a0fb911aea1439.jpg";